// @flow
import Header from '@header/components/Header';
import MainFooter from '@footer/components/MainFooter';
import PaymentFormProvider from '@payment/components/PaymentFormProvider';
import DonationFloatingButton from '@common/components/donation-button/DonationFloatingButton';
import { useCallback, useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { WEB_PATHS } from '@app/constants/paths';
import useAuth from '@user/hooks/useAuth';
import RolesHelpers from '@user/helpers/RolesHelpers';
const { LOGIN,
  SIEL_BLEU_USER_PASSWORD_UPDATE,
  LOGIN_RETURN_SINGLE_SIGN_ON,
  LOGOUT_RETURN_SINGLE_SIGN_ON,
  RESET_KEY_REQUEST } = WEB_PATHS;

type Props = {
  children: React$Node,
};

const Page = (props: Props): React$Node => {
  const { children } = props;
  const location = useLocation();
  const [displayHeader, setDisplayHeader] = useState<boolean>(false);
  const [displayFooter, setDisplayFooter] = useState<boolean>(false);
  const { user, isConnected } = useAuth();

  const pathsWithoutLayout = [
    LOGIN,
    SIEL_BLEU_USER_PASSWORD_UPDATE,
    LOGIN_RETURN_SINGLE_SIGN_ON,
    LOGOUT_RETURN_SINGLE_SIGN_ON,
    RESET_KEY_REQUEST,
  ];

  // Only show donation button for beneficiary users
  const shouldShowDonationButton = useMemo(() => RolesHelpers.isBeneficiary(user), [user]);

  const handleDisplayLayout = useCallback((): void => {
    if (pathsWithoutLayout.includes(location.pathname)) {
      setDisplayHeader(false);
      setDisplayFooter(false);
    } else {
      setDisplayHeader(true);
      if (user && isConnected) {
        setDisplayFooter(false);
      } else {
        setDisplayFooter(true);
      }
    }
  }, [location, user, isConnected]);

  useEffect(() => {
    handleDisplayLayout();
  }, [handleDisplayLayout]);

  return (
    <>
      {
        displayHeader
        && (
          <Header />
        )
      }
      <main className="getphy-site">
        <div className="page">{ children }</div>
      </main>
      {
        displayFooter
        && (
          <MainFooter />
        )
      }
      <PaymentFormProvider />
      { displayHeader && isConnected && shouldShowDonationButton && <DonationFloatingButton /> }
    </>
  );
};

export default Page;
